import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Person } from './person';

@inheritSerialization(AbstractModel)
export class ProviderDriver extends AbstractModel {
  @autoserialize
  providerId: number;

  @autoserializeAs(Person)
  person: Person;

  static OnSerialized(instance: ProviderDriver, json: any): void {
    super.OnSerialized(instance, json);
  }

  static OnDeserialized(instance: ProviderDriver, json: any): void {
    super.OnDeserialized(instance, json);
  }
}
